/**
 * sessionVerify.js
 * sessionVerify returns a boolean indicating whether the session is active or not.
 * It checks the session token stored in localStorage and verifies it with the server.
 */
export const sessionVerify = async () => {
    const sessionToken = localStorage.getItem('sessionToken');
    const url = new URL('/api/auth/sessionVerify', window.location.origin);
    
    return await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${sessionToken}`,
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(data => {
        return data.expired ? false : true;
    })
}
